import { useState } from 'react';
import { ModalContainer } from '../../../../components/ui/ModalContainer';
import { CancelButton } from '../../../../components/ui/CancelButton';
import { CircularProgress } from '@mui/joy';
import { getErrorMessage } from '../../../../utils/errorHelpers';
import { ErrorMessage } from '../../../../components/errors/ErrorMessage';
import { useDeleteVendedorFromVisitaMutation } from '../../../../api/visitasApi';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
    vendedorId: number; 
    visitaId: number;
    nombreVendedor: string;
    prospectadorId: number;
    userId: number;
    isFinished?: boolean
}

export function VendedorItem({ vendedorId, nombreVendedor, visitaId, prospectadorId, userId, isFinished }: Props) {
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [deleteVendedor, { isLoading }] = useDeleteVendedorFromVisitaMutation();

    const handleDelete = async (vendedorId: number) => {
        try {
            setErrorMessage(null);

            await deleteVendedor({
                visitaId,
                vendedorId,
            })
            .unwrap();

            setShowConfirmModal(false);
            
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    return (
        <>
        <li
            className="flex items-center justify-between">
            <div className="flex gap-x-1 items-center">
                <div className="bg-gray-300 rounded-full w-[20px] h-[20px]"></div>
                <p>{nombreVendedor}</p>
            </div>

            {userId === prospectadorId && isFinished == false && (
            <div 
                className="flex items-center h-[20px] cursor-pointer hover:bg-gray-200 rounded-md" 
                onClick={() => setShowConfirmModal(true)}>
                <CloseRoundedIcon sx={{ height: 20, width: 20 }}/>
            </div>
            )}
        </li>

        {showConfirmModal && (
            <ModalContainer>
                <div className="bg-white w-[400px] rounded">
                    <div className="flex justify-end bg-gray-100 rounded">
                        <button onClick={() => setShowConfirmModal(false)}>
                            <CloseRoundedIcon  />
                        </button>
                    </div>
                    <div className="h-full p-3">

                        <p className="font-semibold text-center mb-3">¿Seguro que quiere eliminar al vendedor {nombreVendedor} de esta campaña?</p>

                        {errorMessage && (
                            <div className="my-2">
                                <ErrorMessage
                                    customMessage>
                                    <p className="text-sm">{errorMessage}</p>
                                </ErrorMessage>
                            </div>
                        )}

                        <div className="flex gap-x-2 justify-center">
                            {isLoading
                            ? 
                            <div className="w-[105px] h-[28px] flex items-center justify-center">
                                <CircularProgress sx={{
                                    "--CircularProgress-progressThickness": "4px",
                                    "--CircularProgress-trackThickness": "4px",
                                    "--CircularProgress-size": "25px"
                                }}/>
                            </div>
                            :
                            <>
                            <button
                                onClick={() => handleDelete(vendedorId)}
                                className="bg-red-400 border-2 border-red-500 px-1 py-[2px] rounded-[3px] hover:bg-red-500">
                                <p className="text-sm font-semibold text-white">Eliminar</p>
                            </button>

                            <CancelButton
                                onClick={()=> {
                                    setShowConfirmModal(false);
                                }}/>
                            </>}
                        </div>
                    </div>
                </div>
            </ModalContainer>
        )}
        </>
    );
}
